
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

console.log('🎬 index.tsx loaded, starting React app...');

// Check if we're in OAuth popup mode - detect by hash fragment with access_token
const hashParams = new URLSearchParams(window.location.hash.substring(1));
const accessToken = hashParams.get('access_token');

// Detect OAuth callback - check for access_token in hash
// Note: window.opener may be null due to COOP, so we use localStorage to communicate
if (accessToken) {
  console.log('🔐 OAuth callback detected - access_token in URL hash');
  
  // Store the token in localStorage for the parent window to pick up
  const oauthData = {
    accessToken: accessToken,
    expiresIn: hashParams.get('expires_in') || '3600',
    tokenType: hashParams.get('token_type') || 'Bearer',
    state: hashParams.get('state'),
    timestamp: Date.now()
  };
  localStorage.setItem('oauth_callback_data', JSON.stringify(oauthData));
  console.log('📤 OAuth token stored in localStorage');
  
  // Also try postMessage if opener exists
  if (window.opener) {
    try {
      window.opener.postMessage({
        type: 'OAUTH_CALLBACK',
        ...oauthData
      }, window.location.origin);
      console.log('📤 Also sent via postMessage');
    } catch (e) {
      console.log('postMessage failed (expected with COOP):', e);
    }
  }
  
  // Show success message
  document.body.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#111827;color:white;font-family:sans-serif;"><div style="text-align:center;"><div style="font-size:48px;margin-bottom:16px;">✅</div><div style="font-size:20px;">Authorization successful!</div><div style="font-size:14px;color:#9ca3af;margin-top:8px;">This window will close automatically...</div></div></div>';
  
  // Close popup after 1.5 seconds
  setTimeout(() => window.close(), 1500);
  
  // Stop execution - don't load React
  throw new Error('OAuth popup - stopping React');
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('❌ Could not find root element!');
  throw new Error("Could not find root element to mount to");
}

console.log('✅ Root element found, creating React root...');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

console.log('🚀 React app render initiated...');
